<template>
  <thead >
  <tr v-if="enableColumnGrouping" style="font-weight: bold" class="grouped-columns-header-row">
    <th v-if="lineNumbers"></th>
    <td v-if="selectable"></td>
    <td v-for="group in columnGroups" :colspan="group.colSpan">
      {{group.label}}
    </td>
  </tr>
  <tr>
    <th v-if="lineNumbers" class="line-numbers"></th>
    <th v-if="selectable" class="vgt-checkbox-col">
      <input
        type="checkbox"
        :checked="allSelected"
        :indeterminate.prop="allSelectedIndeterminate"
        @change="toggleSelectAll" />
    </th>
    <th v-for="(column, index) in columns"
      :key="index"
      @click="sort(index)"
      :class="getHeaderClasses(column, index)"
      :style="columnStyles[index]"
      v-if="!column.hidden">
      <slot name="table-column" :column="column">
        <span>{{column.label}}</span>
      </slot>
    </th>
  </tr>
  <tr
    is="vgt-filter-row"
    ref="filter-row"
    @filter-changed="filterRows"
    :global-search-enabled="searchEnabled"
    :line-numbers="lineNumbers"
    :selectable="selectable"
    :columns="columns"
    :mode="mode"
    :typed-columns="typedColumns">
  </tr>
</thead>
</template>

<script>
import assign from 'lodash.assign';
import VgtFilterRow from './VgtFilterRow.vue';

export default {
  name: 'VgtTableHeader',
  props: {
    enableColumnGrouping: {
      default: false,
      type: Boolean
    },
    lineNumbers: {
      default: false,
      type: Boolean,
    },
    selectable: {
      default: false,
      type: Boolean,
    },
    allSelected: {
      default: false,
      type: Boolean,
    },
    allSelectedIndeterminate: {
      default: false,
      type: Boolean,
    },
    columns: {
      type: Array,
    },
    columnGroups: {
      type: Array,
    },
    mode: {
      type: String,
    },
    typedColumns: {},

    //* Sort related
    sortColumn: {
      type: Number,
    },
    sortType: {
      type: String,
    },

    // utility functions
    isSortableColumn: {
      type: Function,
    },
    getClasses: {
      type: Function,
    },

    //* search related
    searchEnabled: {
      type: Boolean,
    },

    tableRef: {},

    paginated: {},
  },
  watch: {
    tableRef: {
      handler() {
        this.setColumnStyles();
      },
      immediate: true,
    },
    paginated: {
      handler() {
        if (this.tableRef) {
          this.setColumnStyles();
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      checkBoxThStyle: {},
      lineNumberThStyle: {},
      columnStyles: [],
    };
  },
  computed: {
  },
  methods: {
    toggleSelectAll() {
      this.$emit('on-toggle-select-all');
    },
    sort(index) {
      this.$emit('on-sort-change', index);
    },
    getHeaderClasses(column, index) {
      const isSortable = this.isSortableColumn(index);
      const classes = assign({}, this.getClasses(index, 'th'), {
        sorting: isSortable,
        'sorting-desc': isSortable && this.sortColumn === index && this.sortType === 'desc',
        'sorting-asc': isSortable && this.sortColumn === index && this.sortType === 'asc',
      });
      return classes;
    },

    filterRows(columnFilters) {
      this.$emit('filter-changed', columnFilters);
    },

    getWidthStyle(dom) {
      const cellStyle = window.getComputedStyle(dom, null);
      return {
        width: cellStyle.width,
      };
    },

    setColumnStyles() {
      const colStyles = [];
      setTimeout(() => {
        for (let i = 0; i < this.columns.length; i++) {
          if (this.tableRef) {
            let skip = 0;
            if (this.selectable) skip++;
            if (this.lineNumbers) skip++;
            const cell = this.tableRef.rows[0].cells[i + skip];
            colStyles.push(this.getWidthStyle(cell));
          } else {
            colStyles.push({
              width: this.columns[i].width ? this.columns[i].width : 'auto',
            });
          }
        }
        this.columnStyles = colStyles;
      }, 200);
    },

    getColumnStyle(column, index) {
      const styleObject = {
        width: column.width ? column.width : 'auto',
      };
      //* if fixed header we need to get width from original table
      if (this.tableRef) {
        if (this.selectable) index++;
        if (this.lineNumbers) index++;

        const cell = this.tableRef.rows[0].cells[index];
        const cellStyle = window.getComputedStyle(cell, null);
        styleObject.width = cellStyle.width;
      }
      return styleObject;
    },
  },
  mounted() {
  },
  components: {
    'vgt-filter-row': VgtFilterRow,
  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// VgtTableHeader.vue?fbe472ca